module.exports = __webpack_public_path__ + "static/img/icon_zanwuwdzs.2eadf0fb.png";